import React from 'react';
import createReactClass from 'create-react-class';

var ProgressMeter = createReactClass({
  getDefaultProps(){
    return {
      title: 'Title',
      color: '#CCCCCC',
      count: 0,
      total: 0
    };
  },

  render() {
    let { count, total, color } = this.props;

    let percent = 0;

    if(count > 0) {
      percent = Math.round((count / total) * 100);
    }

    return (

      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12"> <span className="text"> {this.props.title} <span className="pull-right">{count}/{total}</span> </span>
          <div className="progress">
              <div className="progress-bar" style={{width: `${percent}%`, backgroundColor: `${color}!important`}}></div>
          </div>
      </div>
    );
  }
});

export default ProgressMeter;



// WEBPACK FOOTER //
// ./src/components/dashboard/ProgressMeter.js